import { Col, Row, Toast } from '@kaleyra/emmy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './ApiKeys.module.scss';
import cn from 'classnames';
import CopyImg from '../../../../assets/CopySVG.svg';

export type PropsType = {
	host: string;
	sid: string;
	apiKey: string;
};

const APIDetails: React.FC<PropsType> = ({ host, sid, apiKey }) => {
	const { t } = useTranslation();

	return (
		<>
			<div className={Styles.apiDetailsEdit}>{t('apiDetails')}</div>
			<Row className={Styles.rowMargin}>
				<Col size={4}>
					<div className={Styles.apiKeyTableCol1}>
						{t('apiDomain')}
					</div>
				</Col>
				<Col size={8}>
					<div className={Styles.apiKeyTableCol2}>{host}</div>
				</Col>
			</Row>
			<Row className={cn(Styles.rowE, Styles.rowMargin)}>
				<Col size={4}>
					<div className={Styles.apiKeyTableCol1}>{t('apiSid')}</div>
				</Col>
				<Col size={8} className={Styles.col2}>
					<div className={Styles.apiKeyTableCol2}>{sid}</div>
				</Col>
			</Row>
			<Row className={cn(Styles.rowE, Styles.rowMargin)}>
				<Col size={4}>
					<div className={Styles.apiKeyTableCol1}>{t('apiKey')}</div>
				</Col>
				<Col size={8}>
					<div className={Styles.flexContainer}>
						<div className={Styles.apiKeyP}>{apiKey}</div>
						<div className={Styles.apiKeyImage}>
							<img
								src={CopyImg}
								className={Styles.copyImgEdit}
								onClick={() => {
									navigator.clipboard.writeText(apiKey);
									Toast(
										t('mainCopiedToClipboard'),
										'success',
										() => null
									);
								}}
								alt="copy"
							/>
						</div>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default APIDetails;
